module.exports = __webpack_public_path__ + "img/source.705224eb.png";